module.exports = __webpack_public_path__ + "media/images/logo-ed82152285bcf19eb6e5c212d7d7a171.svg";